<template>
  <div v-if="show" :id="uid" class="container">
    <div :class="`select-box-${uid}`" class="select-box">
      <div v-if="subscores.browser" class="options-container" :class="`options-container-${uid}`">
        <div :key="`${uid}`" style="cursor: pointer;padding: 10px;" :class="`option-${uid}`" @click="() => {}">
            <table style="opacity: 1; color: #000;">
                <tr>
                <th>Subpontuações</th>
                <th></th>
                </tr>
                <tr>
                <td>Distância do endereço de cobrança até o local do ip</td>
                <td>{{ subscores.billing_address_distance_to_up_location }}</td>
                </tr>
                <tr>
                <td>Navegador</td>
                <td>{{ subscores.browser }}</td>
                </tr>
                <tr>
                <td>Estorno</td>
                <td>{{ subscores.chargeback }}</td>
                </tr>
                <tr>
                <td>País</td>
                <td>{{ subscores.country }}</td>
                </tr>
                <tr>
                <td>Incompatibilidade de país</td>
                <td>{{ subscores.country_mismatch }}</td>
                </tr>
                <tr>
                <td>Dispositivo</td>
                <td>{{ subscores.device }}</td>
                </tr>
                <tr>
                <td>Endereço de email</td>
                <td>{{ subscores.email_address }}</td>
                </tr>
                <tr>
                <td>Domínio do email</td>
                <td>{{ subscores.email_domain }}</td>
                </tr>
                <tr>
                <td>Mandato de e-mail</td>
                <td>{{ subscores.email_tenure }}</td>
                </tr>
                <tr>
                <td>Posse de IP</td>
                <td>{{ subscores.ip_tenure }}</td>
                </tr>
                <tr>
                <td>Número de identificação do emissor</td>
                <td>{{ subscores.issuer_id_number }}</td>
                </tr>
                <tr>
                <td>Valor do pedido</td>
                <td>{{ subscores.order_amount }}</td>
                </tr>
                <tr>
                <td>Número de telefone</td>
                <td>{{ subscores.phone_number }}</td>
                </tr>
                <tr>
                <td>Hora do dia</td>
                <td>{{ subscores.time_of_day }}</td>
                </tr>
            </table>
        </div>
      </div>

      <div :id="`selected-${uid}`" style="height: 120px;border: 1px solid #f2f2f2; border-radius: 5px; flex-direction: column;" :class="`selected-${uid}`" class="selected" @click="toggleActive">
        <h4> {{ textValue }} </h4>
        <span>{{ text }}</span>
        <span v-if="subscores.browser" style="cursor: pointer; color: #2196F3; border: none; border-radius: 5px; padding: 10px;">Fatores de Risco</span>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    subscores: {
        type: Object
    },
    uid: {
      type: String,
    },
    text: {
      type: String,
      default: ''
    },
    textValue: {
      type: [String, Number],
      default: '0'
    },
    value: {
      type: String,
    },
    notcolor: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: false // [ { id: Number, name: String } ]
    },
  },
  data() {
    return {
      show: true,
      statusClass: '',
    }
  },
  computed: {
    getValue() {
      return this.value;
    }
  },
//   mounted() {
//     const selected = document.getElementById(`selected-${this.uid}`);

//     const optionsList = document.querySelectorAll(`.option-${this.uid}`);
//     const optionsContainer = document.querySelector(`.options-container-${this.uid}`);

//     optionsList.forEach(o => {
//       o.addEventListener("click", () => {
//         selected.innerHTML = o.querySelector("label").innerHTML;
//         optionsContainer.classList.remove("active");
//       });
//     });
//     this.getStatusClass(this.value);
//   },
  methods: {
    getTextByStatus(status) {
      const text = this.options.filter(f => f.value === status)
      const ok_text = text.length ? text[0].text : this.text;
      return ok_text;
    },
    toggleActive() {
      const optionsContainer = document.querySelector(`.options-container-${this.uid}`);
      optionsContainer.classList.toggle("active");
    },
    onInput(value) {
      this.$emit('change', value);
      this.getStatusClass(value);
    },
    getStatusClass(value) {
      this.show = false;
      this.statusClass = `status--${value}`
      setTimeout(() => {
        this.show = true;
      }, 80)
    }
  }
}
</script>

<style scoped>
  .container {
    padding: 6px;
    width: 200%;
    z-index: 20;
  }

  .select-box {
    display: flex;
    width: 100%;
    flex-direction: column;
  }

  .select-box .options-container {
    padding-top: 12px;
    padding-bottom: 12px;
    background: #fff;
    color: #f5f6fa;
    max-height: 0;
    width: 600px;
    opacity: 0;
    transition: all 0.4s;
    border-radius: 3px;
    overflow: auto;
    position: absolute;
    margin-top: 120px;
    z-index: 20;
    box-shadow: 0 0 1em rgba(0,0,0,0.1);

    order: 1;
  }

  .selected {
    background: rgba(0,0,0,0);
    border-radius: 8px;
    margin-bottom: 8px;
    color: #f5f6fa;
    opacity: 1;
    width: 200px;
    position: relative;

    order: 0;
  }

  .selected::after {
    content: "";
    background-size: contain;
    background-repeat: no-repeat;

    position: absolute;
    height: 100%;
    width: 27px;
    right: 10px;
    top: 20px;

    transition: all 0.4s;
  }

  .select-box .options-container.active {
    min-height: 400px;
    opacity: 1 !important;
    background-color: rgba(255, 255, 255, 1);
    overflow-y: scroll;
  }

  .select-box .options-container.active + .selected::after {
    transform: rotateX(180deg);
    top: -10px;
  }

  .select-box .selected {
    padding: 12px 0px;
    cursor: pointer;
    color: #333;
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  .select-box .option {
    padding: 0px 12px;
    display: flex;
    margin-left: 12px;
    align-items: center;
    z-index: 20;
  }

  .select-box .option:hover {
    background: #fbfbfa;
    border-radius: 6px;
  }

  .select-box label {
    cursor: pointer;
  }



  .radio {
    height: 40px;
  }

  .status {
    width: 6px;
    height: 6px;
    background: #333;
    border-radius: 50%;
    margin-right: 6px;
    transition: all 0.3s ease;
  }

  .status--big {
    width: 12px;
    height: 12px;
    margin-bottom: 6px;
    margin-right: 24px;
  }
  table {
    min-width: 100%;
    border-radius: 5px;
    }

    td, th {
    border: 1px solid #ddd;
    text-align: left;
    padding: 8px;
    }

    th {
    background-color: #f0faf0;
    }
</style>
